import React, { useState } from 'react';
import { useEventImages } from '../map/hooks/useEventImages';
import { useEventInterest } from '../map/hooks/useEventInterest';
import EventSlider from './components/EventSlider';
import EventHeader from './components/EventHeader';
import EventDescription from './components/EventDescription';
import EventInfo from './components/EventInfo';
import EventFooter from './components/EventFooter';
import ImageModal from './components/ImageModal';
import ShareButton from './components/ShareButton';
import WeatherInfo from './components/WeatherInfo'; // ⬅️ NUOVO IMPORT
import CalendarButton from './components/CalendarButton'; // ⬅️ AGGIUNGI IMPORT

import {
  SidebarContainer,
  SidebarContent,
  SidebarOverlay,
  LoadingContainer,
  MobileScrollContainer,
  LastUpdateInfo
} from './styles/EventSidebar.styles';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

const EventSidebar = ({ isOpen, event, loading, error, onClose }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  
  // Custom hooks
  const {
    eventImages,
    currentSlideIndex,
    nextSlide,
    prevSlide,
    goToSlide
  } = useEventImages(event);

  const {
    isInterested,
    interestCount,
    isLoading: interestLoading,
    handleInterestToggle
  } = useEventInterest(event?.id);

  console.log('EventSidebar - evento ricevuto:', event);
  console.log('EventSidebar - immagini trovate:', eventImages);

  if (!isOpen) return null;

  // Funzione per aprire il modal dell'immagine
  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  // Funzione per chiudere il modal dell'immagine
  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <SidebarContainer isOpen={isOpen}>
        {loading ? (
          <LoadingContainer>
            <div>Caricamento dettagli evento...</div>
          </LoadingContainer>
        ) : error ? (
          <LoadingContainer>
            <div>Errore: {error}</div>
          </LoadingContainer>
        ) : !event ? (
          <LoadingContainer>
            <div>Evento non trovato</div>
          </LoadingContainer>
        ) : (
          <>
            <MobileScrollContainer>
              {/* Slider Immagini */}
              <EventSlider
                eventImages={eventImages}
                currentSlideIndex={currentSlideIndex}
                nextSlide={nextSlide}
                prevSlide={prevSlide}
                goToSlide={goToSlide}
                onImageClick={handleImageClick}
                eventTitle={event.title}
              />
              
              {/* Pulsante Condivisione e Calendario affiancati */}
              <div style={{ 
                padding: '16px 20px', 
                borderTop: '1px solid #eee',
                display: 'flex',
                alignItems: 'center'
              }}>
                <ShareButton event={event} />
                <CalendarButton event={event} />
              </div>


              {/* Header con titolo */}
              <EventHeader event={event} />

              {/* ⬇️ METEO - INSERITO QUI */}
              <WeatherInfo event={event} />
       
              {/* Contenuto scrollabile */}
              <SidebarContent>
                {/* Descrizione espandibile */}
                <EventDescription 
                  description={event.description}
                  eventId={event.id}
                />
                
                {/* Sezione Informazioni */}
                <EventInfo event={event} />
              </SidebarContent>

              {/* Info ultimo aggiornamento */}
              {!loading && !error && event && (
                <LastUpdateInfo>
                  Ultimo aggiornamento: {format(new Date(), 'dd/MM/yyyy HH:mm', { locale: it })}
                </LastUpdateInfo>
              )}
            </MobileScrollContainer>

            {/* Footer con pulsanti - SEMPRE fisso in basso */}
            <EventFooter
              event={event}
              onClose={onClose}
              isInterested={isInterested}
              interestCount={interestCount}
              isLoading={interestLoading}
              onInterestToggle={handleInterestToggle}
            />
          </>
        )}
      </SidebarContainer>

      {/* Modal per visualizzare l'immagine a schermo intero */}
      <ImageModal
        selectedImage={selectedImage}
        onClose={handleCloseModal}
      />
      
      {/* Overlay per mobile */}
      <SidebarOverlay isOpen={isOpen} onClick={onClose} />
    </>
  );
};

export default EventSidebar;

